import {observable} from 'mobx';
import {getExchangeRate} from '../currency/CurrencyAPI';
import {moneyFormat, NumericFormatter} from '../utility/FormatValueUtils';
import {Channel} from '../types/Channel';

export interface ExchangeRates {
    [currencyCode: string]: number;
}

export interface CurrencyState {
    moneyFormatToTargetCurrency: (fractions?: number) => NumericFormatter;
    applyTargetCurrencyConversionToNumber: (value: number, channelCurrency: string) => number;
    ensureTargetCurrency: (availableChannels: Channel[]) => void;
    loadExchangeRatesBasedOnEuro: () => void;
    targetCurrency?: string;
}

export default class CurrencyStore {
    @observable private exchangeRates?: ExchangeRates;
    @observable public targetCurrency?: string;

    public loadExchangeRatesBasedOnEuro = () => {
        getExchangeRate()
            .then((resp) => {
                this.exchangeRates = resp.data.rates;
            })
            .catch(() => {
                this.exchangeRates = undefined;
            });
    };

    public ensureTargetCurrency(availableChannels: Channel[]) {
        if (availableChannels.length > 0) {
            const channelMatchForTargetCurrency = availableChannels.some((channel) => channel.currency === this.targetCurrency);
            if (!channelMatchForTargetCurrency) {
                this.targetCurrency = availableChannels[0].currency;
                return;
            }
            return;
        }
        this.targetCurrency = undefined;
    }

    public applyTargetCurrencyConversionToNumber = (value: number, channelCurrency: string): number => {
        const baseCurrencyExchangeRate = this.getExchangeRateForCurrency(channelCurrency);
        const targetCurrencyExchangeRate = this.getExchangeRateForCurrency(this.targetCurrency);
        return (targetCurrencyExchangeRate * value) / baseCurrencyExchangeRate;
    };

    public moneyFormatToTargetCurrency = (fractionDigits = 2): NumericFormatter => {
        return moneyFormat({currency: this.targetCurrency});
    };

    private getExchangeRateForCurrency(currencyName?: string): number {
        return this.exchangeRates && currencyName && this.exchangeRates[currencyName] ? this.exchangeRates[currencyName] : 1;
    }
}



// WEBPACK FOOTER //
// ./src/stores/CurrencyStore.ts